<template>
  <EntityStatistics
    :title="'Veranstaltungen: Statistiken'"
    :name="'Veranstaltungen'"
    :entityType="'event'"
    :configAction="'getEventsConfig'"
    :latestDataEndpoint="env.events_api_client_url + 'event'"
    :matomoEndpoint="'https://matomo.api.eo-heimat.de'"
    :matomoSiteId="isDevEnvironment ? 7 : 8"
    :matomoTokenAuth="'72d0c8747156029f020882bb77535ca1'"
    :overviewTitle="'Alle Veranstaltungen'"
    :overviewLink="'/events/statistics/overview'"
  />
</template>

<script setup>
import EntityStatistics from "@/components/Statistics/EntityStatistics.vue";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);
const isDevEnvironment = ["env.dev", "env.local"].some(env =>
  process.env.VUE_APP_ENV_PATH.includes(env)
);
</script>
